import React from 'react'
import HeroBg from 'assets/image/about-us/hero.png'

const Hero = () => {
  return (
    <section
      className="pt-[88px] pb-[188px] md:py-140px] px-6 md:px-16 md:text-center flex flex-col justify-center md:items-center bg-cover"
      style={{ backgroundImage: `url('${HeroBg}')` }}
    >
      <button className="w-fit text-xs md:text-base border border-white rounded-full font-medium text-white px-[23px] py-[11.5px] mb-4 md:mb-[35.5px]">
        About Us
      </button>
      <h1 className="title whitespace-pre-line font-[700] text-[32px] md:text-[48px] lg:text-[56px] md:text-center mx-auto leading-[150%] md:leading-[150%] xl:leading-[120%] text-white max-w-[766px] lg:max-w-[1024px]">
        Manuva is Indonesia’s biggest End-to-End Supply Chain platform for SME
        Manufacturers
      </h1>
      <p className="mt-4 md:mt-6 leading-[150%] md:text-[16px] font-normal text-white md:text-center">
        We are digitizing the enormous and untapped segment of SME
        Manufacturers in Indonesia
      </p>
    </section>
  )
}

export default Hero
